module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/rinse_conditioner-fd8ff971c58204f2f4d6788a537d1361.svg";